import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useMemo, useRef, useState } from "react";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import moment from "moment";
import PieChart from "../../Services/Charts/PieChart";
import { EVENT_TYPE_FILTER_OPTIONS, EVENT_TYPE_LABEL_MAP } from "../events/constants";
const MembersAttendanceReport = () => {
    const dispatch = useDispatch();
    const [showFilter, setShowFilter] = useState(true);
    const { userData, accessToken } = useSelector((state) => state.user);
    const [memList, setMemList] = useState([]);
    const [typeSummary, setTypeSummary] = useState([]);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const tableRef = useRef(null);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") ? 0 : userData.user_div,
        mem_id: 0,
        event_type: "all",
        sort_by: 'priority',
        sort_order: 'DESC',
    });
    const attendanceStatusSummary = useMemo(() => {
        return memList.reduce((acc, item) => {
            acc.present += parseInt(item.total_present || 0);
            acc.late += parseInt(item.total_late || 0);
            acc.absent += parseInt(item.total_absent || 0);
            acc.leave += parseInt(item.total_leaves || 0);
            acc.outStation += parseInt(item.total_out_station || 0);
            acc.intlKhidmat += parseInt(item.total_intl || 0);
            acc.noResponse += parseInt(item.no_responses || 0);
            return acc;
        }, {
            present: 0,
            late: 0,
            absent: 0,
            leave: 0,
            outStation: 0,
            intlKhidmat: 0,
            noResponse: 0
        });
    }, [memList]);
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId || orgId === 0) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList])
    useEffect(() => {
        dispatch(setPageTitle(`Members Attendance Report`));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    runFilter();
                })
                .catch(err => {
                    console.log(err);
                })
        }
        else {
            runFilter();
        }
    }, [accessToken, dispatch]);
    const runFilter = () => {
        dispatch(setMainLoading(true));
        PostAxios(`reports/members-attendance-reports`, filter, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setMemList(data.data);
                    setTypeSummary(data.summary || []);
                }
                else {
                    setMemList([]);
                    setTypeSummary([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const exportReport = () => {
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('org_id', filter.org_id);
        form_data.append('div_id', filter.div_id);
        form_data.append('mem_id', filter.mem_id);
        form_data.append('event_type', filter.event_type);
        form_data.append('sort_by', filter.sort_by);
        form_data.append('sort_order', filter.sort_order);
        form_data.append('token', accessToken);
        fetch(`${process.env.REACT_APP_API_URL}reports/export-members-attendance-reports`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
            .then(response => {
                const blob = response.blob();
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                let fileName = `members-attendance-report-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return <>
        <div className="main-form-sec">
            <div className="top-reports-filter">
                <div className={`right-filter-sec`}>
                    <button className="filter-toggle" onClick={() => {
                        setShowFilter(!showFilter);
                    }}>
                        <i className="fa-solid fa-filter"></i>
                    </button>
                    <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                        {
                            userData.role_slug === "super_admin" &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => {
                                            setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })
                                        }}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Division</label>
                                <div className="static-items-outer">
                                    <select
                                        id="div_id"
                                        name="div_id"
                                        className="select-input"
                                        value={filter.div_id}
                                        onChange={(e) => {
                                            filterHandler("div_id", e.target.value)
                                        }}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                        }
                                    </select>
                                </div>
                            </div>

                        }
                        <div className="report-filter-field">
                            <label className="select-input-outer">Event Type</label>
                            <div className="static-items-outer">
                                <select
                                    id="event_type"
                                    name="event_type"
                                    className="select-input"
                                    value={filter.event_type}
                                    onChange={(e) => {
                                        filterHandler("event_type", e.target.value)
                                    }}
                                >
                                    {EVENT_TYPE_FILTER_OPTIONS.map((item) => (
                                        <option key={`event-type-${item.value}`} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="report-filter-field">
                            <label className="select-input-outer">Sort By</label>
                            <div className="static-items-outer">
                                <select
                                    id="sort_by"
                                    name="sort_by"
                                    className="select-input"
                                    value={filter.sort_by}
                                    onChange={(e) => {
                                        filterHandler("sort_by", e.target.value)
                                    }}
                                >
                                    <option value='priority'>Priority (Intl {'>'} Safar {'>'} Local)</option>
                                    <option value='1'>Present</option>
                                    <option value='2'>Late</option>
                                    <option value='3'>Absent</option>
                                    <option value='4'>Out of Satation</option>
                                    <option value='5'>INTL</option>
                                    <option value='6'>Leave</option>
                                </select>
                            </div>
                        </div>
                        <div className="report-filter-field">
                            <label className="select-input-outer">Sort Order</label>
                            <div className="static-items-outer">
                                <select
                                    id="sort_order"
                                    name="sort_order"
                                    className="select-input"
                                    value={filter.sort_order}
                                    onChange={(e) => {
                                        filterHandler("sort_order", e.target.value)
                                    }}
                                >
                                    <option value='DESC'>Descending</option>
                                    <option value='ASC'>Ascending</option>
                                </select>
                            </div>
                        </div>
                        <button type="button" className="btn btn-blue ms-2" onClick={() => { runFilter() }}>Submit</button>
                    </div>
                </div>
            </div>

        </div>
        {
            memList.length > 0 &&
            <div className="main-form-sec">
                <div className="top-right-btn p-0">
                    <button type="button" className="btn btn-blue ms-2" onClick={() => {
                        exportReport();
                    }}>Export to Excel</button>
                </div>
                {/* <PointsLegend /> */}
                {
                    typeSummary.length > 0 &&
                    <div className="w-100 d-flex flex-wrap mb-3">
                        <div className="w-50 p-2">
                            <PieChart options={{
                                chart: { type: "column", height: 320 },
                                title: { text: "Events Count by Type" },
                                tooltip: {
                                    pointFormat: "<b>{point.y}</b>"
                                },
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: true,
                                            formatter: function () {
                                                return this.y;
                                            }
                                        }
                                    }
                                },
                                xAxis: {
                                    categories: typeSummary.map((item) => EVENT_TYPE_LABEL_MAP[item.event_type] || "Local"),
                                    title: { text: "Event Type" }
                                },
                                yAxis: {
                                    min: 0,
                                    title: { text: "Total Events" }
                                },
                                series: [
                                    {
                                        name: "Events",
                                        data: typeSummary.map((item) => parseInt(item.total_events || 0)),
                                        colorByPoint: true,
                                    }
                                ],
                                legend: { enabled: false }
                            }} />
                        </div>
                        <div className="w-50 p-2">
                            <PieChart options={{
                                chart: { type: "column", height: 320 },
                                title: { text: "Attendance Status Counts" },
                                tooltip: {
                                    pointFormat: "<b>{point.y}</b>"
                                },
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: true,
                                            formatter: function () {
                                                return this.y;
                                            }
                                        }
                                    }
                                },
                                xAxis: {
                                    categories: ["Present", "Late", "Absent", "Leave", "Out of Station", "INTL Khidmat", "No Response"],
                                    title: { text: "Attendance Status" }
                                },
                                yAxis: {
                                    min: 0,
                                    title: { text: "Count" }
                                },
                                series: [
                                    {
                                        name: "Attendance",
                                        data: [
                                            attendanceStatusSummary.present,
                                            attendanceStatusSummary.late,
                                            attendanceStatusSummary.absent,
                                            attendanceStatusSummary.leave,
                                            attendanceStatusSummary.outStation,
                                            attendanceStatusSummary.intlKhidmat,
                                            attendanceStatusSummary.noResponse
                                        ],
                                        colorByPoint: true,
                                    }
                                ],
                                legend: { enabled: false }
                            }} />
                        </div>
                    </div>
                }
                <div className="table-wrapper">
                    <table className="table" ref={tableRef}>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Name</th>
                                <th>ITS</th>
                                <th>Division</th>
                                <th>Mohallah</th>
                                <th>Registered</th>
                                <th>Intl Events</th>
                                <th>Safar Events</th>
                                <th>Local Events</th>
                                <th>Intl Attended</th>
                                <th>Safar Attended</th>
                                <th>Local Attended</th>
                                <th>Present</th>
                                <th>Present {`(Late)`}</th>
                                <th>Absent</th>
                                <th>Leave</th>
                                <th>Out of Station</th>
                                <th>INTL Khidmat</th>
                                <th>No Response</th>
                                <th>Total Points</th>
                                <th>Priority Rank</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                memList.map((item, index) => {
                                    const isTopFive = index < 5;
                                    return <tr key={`member-attendance-${index}`} style={isTopFive ? { backgroundColor: '#fff3cd' } : {}}>
                                        <td>{index + 1}</td>
                                        <td>{item.full_name.toUpperCase()}</td>
                                        <td>{item.user_its}</td>
                                        <td>{item.division_number}</td>
                                        <td>{item.division_name.toUpperCase()} </td>
                                        <td>{item.total_events_registered}</td>
                                        <td>{item.total_intl_events}</td>
                                        <td>{item.total_safar_events}</td>
                                        <td>{item.total_local_events}</td>
                                        <td>{item.intl_attended}</td>
                                        <td>{item.safar_attended}</td>
                                        <td>{item.local_attended}</td>
                                        <td>{item.total_present}</td>
                                        <td>{item.total_late}</td>
                                        <td>{item.total_absent}</td>
                                        <td>{item.total_leaves}</td>
                                        <td>{item.total_out_station}</td>
                                        <td>{item.total_intl}</td>
                                        <td>{item.no_responses}</td>
                                        <td>{item.total_points}</td>
                                        <td>{isTopFive ? `Top ${index + 1}` : "-"}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }
    </>;
}
export default MembersAttendanceReport;